import { BaseActivityBasicModel } from '../base-activity-basic.model';

export interface DigitalFilingActivityBasicModel extends BaseActivityBasicModel {}
